import { Container } from '@mui/material';
import { PageStyled } from './index.styles';
import { useMediaScreen } from 'common/theme/media';
import BusSearchBar from '../bus-search-bar';

const CityHeaderSection = (props: any) => {
    const media = useMediaScreen();
    return (
        <PageStyled style={{ backgroundImage: `url(${props.img})` }}>
            <Container className="container" maxWidth="lg">
                <div className="text">
                    <h1 className="title">
                        {props.title} {props.subtitle && <b> {props.subtitle}</b>}
                    </h1>
                </div>
                <div className="search">
                    <BusSearchBar gtm={props.gtm} data={props.data} showDetail={media.width > 600 ? false : true} />
                </div>
            </Container>
        </PageStyled>
    );
};

export default CityHeaderSection;
